export const EmailRegex = /^[A-Za-z0-9+._%'-]+@[A-Za-z0-9.-]+\.[a-zA-Z]{2,}$/
